import React from 'react';
import { Form, Input } from 'antd';

const FormTextRequired = ({ message, required, maxLength, formName }) => {
  return (
    <Form.Item
      name={formName ?? "name"}
      rules={[
        {
          required: required,
          message: message,
        },
      ]}
    >
      <Input maxLength={maxLength ?? 256} />
    </Form.Item>
  );
};

export default FormTextRequired;
